export class ValidTrustName implements ng.IDirective {
    public restrict = "A";
    public require = "ngModel";
  
    public link = (scope: any, element: any, attrs: any, ngModelCtrl: any) => {
      $(() => {
          ngModelCtrl.$validators.validTrustName = (modelValue, viewValue): boolean => {
              if (modelValue == null || modelValue == '') return true;
            const regExp = RegExp("^(?!\\.+$)(?!-+$)[\\p{L}\\p{Mn}\\p{Pd}'.,\\s\\d]+$", "gmu");
            return regExp.test(modelValue);
          };
      });
    }
  }  